export default "__VITE_ASSET__CpsLSnLb__"